
































import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// utils lib
import moment from 'moment'
import 'tippy.js/dist/tippy.css'
import { cloneDeep, orderBy, uniqueId } from 'lodash'

// Calendar lib
import FullCalendar from '@fullcalendar/vue'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import jaLocale from '@fullcalendar/core/locales/ja'

// Helpers
import { localStore } from '@/_utils/localstore'
import { Debounce } from '@/_utils/utils'
import { Constant } from '@/_services/constant'
import { CalendarViewType } from '@/_enums/calendar_view'

// Worker
// import { calcUserDataCsv } from '../../_worker/web-worker-api'

// Models
import BeaconModel from '@/_models/BeaconModel'
import {
  AnalysisWrapperPlaceModel,
  AnalysisWrapperUserModel,
  RecordDestructPlace,
  RecordDestructUser,
} from '@/_models/AnalysisModel'

// Interface
import { EventInterface, ITimelineCSVExport, IDropdownList } from '@/_interfaces'

// Components
import LegendTitle from '@/components/timeline/partials/LegendTitle.vue'
import TimeLineMixins from './mixins/TimeLineMixin.vue'
import ExportCSVButtons from './partials/ExportCSVButtons.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'

@Component({
  components: { DropdownSearch, ExportCSVButtons, FullCalendar, LegendTitle },
  computed: {},
})
export default class TimelineView extends mixins(TimeLineMixins) {
  get calendarOptions() {
    return {
      schedulerLicenseKey: '0386226177-fcs-1614218751',
      plugins: [interactionPlugin, resourceTimeGridPlugin, resourceTimelinePlugin],
      locale: localStore.getItem('lang') === 'jp' ? jaLocale : undefined,
      customButtons: {
        customSwitchViewType: {
          text: this.isPlaceMode ? this.$t('button.user_mode') : this.$t('button.place_mode'),
          click: () => {
            this.isPlaceMode = !this.isPlaceMode
          },
        },
        dayViewType: {
          text: 'day',
          click: () => {
            const dateToGo = this.getDateToGo(CalendarViewType.day)
            this.getCalendarApi()?.changeView('resourceTimelineDay', dateToGo)
          },
        },
        weekViewType: {
          text: 'week',
          click: () => {
            const dateToGo = this.getDateToGo(CalendarViewType.day)
            this.getCalendarApi()?.changeView('resourceTimelineWeek', dateToGo)
          },
        },
        monthViewType: {
          text: 'month',
          click: () => {
            const dateToGo = this.getDateToGo(CalendarViewType.day)
            this.getCalendarApi()?.changeView('resourceTimelineMonth', dateToGo)
          },
        },
      },
      datesSet: this.onCallendarChange,
      initialView: 'resourceTimelineDay',
      events: this.isPlaceMode ? this.eventsPlace : this.eventsUser,
      eventMouseEnter: this.eventRender,
      initialDate: this.dateFrom,
      nowIndicator: false,
      contentHeight: 'auto',
      height: 'auto', // will activate stickyHeaderDates automatically
      headerToolbar: {
        start: 'prev today next',
        center: 'title',
        right:
          'resourceTimelineDay,dayViewType,resourceTimelineWeek,weekViewType,resourceTimelineMonth,monthViewType customSwitchViewType',
      },
      businessHours: {
        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday
        startTime: '00:00',
        endTime: '24:00',
      },
      navLinks: true,
      eventMinWidth: 0,
      views: {
        resourceTimelineYear: {
          slotLabelFormat: [{ month: 'short' }, { week: 'short' }],
          slotDuration: {
            week: 1,
          },
        },
        resourceTimelineMonth: {
          slotLabelFormat: [{ month: '2-digit' }, { week: 'short' }, { day: '2-digit' }],
          weekNumbers: true,
        },
        resourceTimelineWeek: {
          slotLabelFormat: [{ week: 'short' }, { day: '2-digit' }],
          slotDuration: '24:00:00',
        },
        resourceTimelineDay: {
          // type:  'resourceTimelineDay',
          // buttonText: 'day',
          slotLabelFormat:
            Number(this.selectedSlotDuration) > 5
              ? [{ week: 'short' }, { hour: 'numeric', meridiem: 'short' }]
              : [{ week: 'short' }, { hour: 'numeric', meridiem: 'short' }, { minute: '2-digit' }],
          slotDuration: `00:${this.selectedSlotDuration}:00`,
          scrollTime: '08:00:00',
        },
      },
      allDaySlot: false,
      resourceAreaColumns: this.resourceAreaColumns,
      resources: this.temporaryResourceMediate,
    }
  }

  get timelineCSVInfo(): ITimelineCSVExport {
    return {
      csvValues: this.csvValues,
      isCSVAlready: this.isCSVAlready,
      csvFields: this.csvFields,
      csvFileName: this.csvFileName,
    }
  }

  get dropdownList(): IDropdownList[] {
    if (this.isPlaceMode) {
      return [
        {
          value: 'f_name',
          label: this.$t('label.floor').toString(),
        },
        {
          value: 'l_name',
          label: this.$t('label.place').toString(),
        },
      ]
    }

    return [
      {
        value: 'u_name',
        label: this.$t('label.username').toString(),
      },
      {
        value: 's_id',
        label: this.$t('label.card_number').toString(),
      },
    ]
  }

  @Watch('isPlaceMode')
  isPlaceModeChanged() {
    this.resetFiltersData(this.isPlaceMode ? 'f_name' : 'u_name')
    this.filterUtilPlaceMode.save(this.isPlaceMode)

    // reset state when change mode
    this.clearFetchTimeOut()
    this.loadedEvtsDateRange = ''
  }

  @Watch('filtersData.selectedFilter')
  onSelectFilterChange(newValue: string, oldValue: string) {
    if (oldValue === 'u_name' && newValue === 'f_name' && !this.filtersData.searchQuery.trim().length) {
      return
    }

    this.temporaryResourceMediate = this.handleFilterResource(this.resources, this.filtersData.searchQuery)
  }

  @Watch('filtersData.searchQuery')
  searchQueryChange(newValue: string, oldValue: string) {
    this.temporaryResourceMediate = this.handleFilterResource(this.resources, newValue)
  }

  @Watch('beacons')
  refetchTimelineWhenBeaconsChange() {
    const api = this.getCalendarApi()
    api?.refetchEvents()
  }

  @Debounce(100)
  @Watch('pageFilters', { deep: true })
  onDateFromChange(newVal, oldVal) {
    const oldFilter = cloneDeep(oldVal)
    const daysChanged = moment.duration(moment(oldFilter.dateTo).diff(moment(oldFilter.dateFrom))).asDays()
    const isMonth = daysChanged >= 25
    const isWeek = daysChanged >= 6
    // check days count change for update view
    this.currentDateView = isMonth
      ? CalendarViewType.month
      : isWeek
      ? CalendarViewType.week
      : CalendarViewType.day

    // Function check date for jump as cutomers request https://app.shortcut.com/sango-tech/story/17536/work-recorder-change-the-center-date-on-the-table
    const startMonth = 1 + moment(newVal.dateFrom, 'YYYY/MM/DD').month()
    const endMonth = 1 + moment(newVal.dateTo, 'YYYY/MM/DD').month()
    const saveMonth = 1 + moment(this.lastDayToJump, 'YYYY/MM/DD').month()
    if (isWeek && (startMonth !== endMonth || saveMonth !== endMonth)) {
      this.lastDayToJump = null
    } else if (!isWeek) {
      this.lastDayToJump = newVal.dateTo
    }
  }

  @Debounce(200)
  onCallendarChange(event) {
    const { isSameTodayWithRange } = this.saveFilter(event)
    if (isSameTodayWithRange && !this.timeOut) {
      this.fetchDataEachMinute()
    } else {
      this.clearFetchTimeOut()
    }

    this.stateDateChange(event)
  }

  async eventsPlace(info, successCallback, failureCallback) {
    const isFetchEachMinutes = await this.initEvents(info, 'place')
    const events: EventInterface[] = []

    await this.calendarsData.map((data: AnalysisWrapperPlaceModel) => {
      if (!data.records?.length) {
        return
      }

      const destructedRecored: RecordDestructPlace[] = this.destructingRecords(data.records)
      const beacon = this.getBeaconByMiMn(data.ma, data.mi, `${data.f_name}-${data.l_name}`)

      for (const record of destructedRecored) {
        const user = this.getUserHoldingDevice(record.s_id, record.u_name)

        if (!user) {
          return
        }

        const startHour = moment(record.date_start).format('HH:mm:ss')
        const endHhour = moment(record.date_end).format('HH:mm:ss')
        const description = `${startHour} - ${endHhour}: ${user.name}(${record.s_id || data.s_id})`
        events.push({
          id: uniqueId(),
          // Resource ID is 0 if outside
          resourceId: beacon?._id || '0',
          color: user.category_color,
          title: user.name,
          description,
          start: moment(record.date_start).format(),
          end: moment(record.date_end).format(),
        })
        // build data for csv export
        this.csvValues.push({
          san_id: `${user.san_id}`,
          beacon_id: beacon?._id || '0',
          beacon_uuid: beacon?.beacon_uuid || 'Outside',
          place_name: data.l_name || beacon?.location_name,
          floor: data.f_name || beacon?.floor_name,
          beacon_major: data.ma,
          beacon_minor: data.mi,
          user_name: user.name,
          start_at: moment(record.date_start).format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment(record.date_end).format('YYYY-MM-DD HH:mm:ss'),
        })
      }
    })

    if (isFetchEachMinutes) {
      this.fetchDataEachMinute()
    }

    this.processFinalEvents(events, successCallback)
  }

  async eventsUser(info, successCallback, failureCallback) {
    const isFetchEachMinutes = await this.initEvents(info, 'user')
    const events: EventInterface[] = []

    await this.calendarsData.map((data: AnalysisWrapperUserModel) => {
      if (!data.records?.length) {
        return
      }

      const destructedRecords: RecordDestructUser[] = this.destructingRecords(data.records)

      const user = this.getUserHoldingDevice(data.s_id || data.b_id)
      if (!user) {
        return
      }

      for (const record of destructedRecords) {
        const color = this.stringToColor(record.l_name)

        let locationStr = 'Outside'
        let beacon: BeaconModel = new BeaconModel()

        // Resource ID is 0 if outside
        if ((record.ma && record.mi) || (record.l_name && record.f_name)) {
          beacon = this.getBeaconByMiMn(record.ma, record.mi, `${record.f_name}-${record.l_name}`)
          locationStr = beacon ? `${beacon?.location_name || ''}(${beacon?.floor_name || ''})` : locationStr
        }

        const startHour = moment(record.date_start).format('HH:mm:ss')
        const endHhour = moment(record.date_end).format('HH:mm:ss')
        const description = `${startHour} - ${endHhour}: ${locationStr}`

        events.push({
          color,
          id: uniqueId(),
          resourceId: data.s_id || `${user.major}-${user.minor}`,
          title: `${record.l_name}`,
          description,
          start: moment(record.date_start).format(),
          end: moment(record.date_end).format(),
        })

        // build data for csv export
        this.csvValues.push({
          san_id: `${data.s_id}`,
          beacon_id: beacon?._id,
          beacon_uuid: beacon?.beacon_uuid,
          place_name: record.l_name,
          floor: record.f_name,
          beacon_major: record.ma || user.major,
          beacon_minor: record.mi || user.minor,
          user_name: user.name,
          start_at: moment(record.date_start).format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment(record.date_end).format('YYYY-MM-DD HH:mm:ss'),
        })
      }
    })

    if (isFetchEachMinutes) {
      this.fetchDataEachMinute()
    }
    this.processFinalEvents(events, successCallback)
  }

  async initEvents(info, modeFetch: string) {
    this.isCSVAlready = false

    const { dateFromStr, dateToStr, isCallSameDate, isSameTodayWithRange } = this.saveFilter(info)
    let isFirstloading: boolean = true

    if (this.timeOut) {
      if (isSameTodayWithRange && isCallSameDate) {
        isFirstloading = false
      }
      this.clearFetchTimeOut()
    }

    await this.$store.dispatch('analysis/getAllAnalysisWrapper', {
      date_from: dateFromStr,
      date_to: dateToStr,
      gmt: -(new Date().getTimezoneOffset() / 60),
      mode: modeFetch,
      loading: isFirstloading,
    })

    this.csvValues.length = 0

    return isSameTodayWithRange
  }

  processFinalEvents(events: EventInterface[], successCallback) {
    successCallback(events.map(event => event))
    // Make sure UI not crash
    setTimeout(() => {
      this.removeDuplicateCSV()
      this.isCSVAlready = true
    }, 1000)
  }

  async fetchDataEachMinute() {
    const calendar = await this.getCalendarApi()
    this.calculatorCenPos(calendar)

    if (calendar) {
      this.timeOut = setTimeout(() => {
        calendar.refetchEvents()
      }, Constant.FETCH_TIME_MINUTES * (10 + 60) * 1000) // minutes * (1.1) seconds * miliseconds
    }
  }

  saveFilter(event: any) {
    const dateFromStr = moment(event.start).format(Constant.DATE_FORMAT_QUERY)
    const dateToStr = moment(event.end).subtract(1, 'seconds').format(Constant.DATE_FORMAT_QUERY)
    const isCallSameDate = this.loadedEvtsDateRange === `${dateFromStr}/${dateToStr}`
    const isSameTodayWithRange = this.isSameTodayWithRange(dateFromStr, dateToStr)

    this.pageFilters.dateFrom = dateFromStr
    this.pageFilters.dateTo = dateToStr

    this.filterUtilPage.save(this.pageFilters)
    this.loadedEvtsDateRange = `${dateFromStr}/${dateToStr}`
    return { dateFromStr, dateToStr, isCallSameDate, isSameTodayWithRange }
  }

  removeDuplicateCSV() {
    if (!this.csvValues?.length) {
      return
    }

    // Remove duplicate time slot
    const resultsSorted = orderBy(this.csvValues, ['user_name', 'start_at'], ['asc', 'asc'])
    const rowLength = resultsSorted.length
    const newCsvValues: any = [resultsSorted[0]]

    for (let i = 1; i < rowLength; i++) {
      const prevStartAt = moment(resultsSorted[i - 1].start_at)
      const prevEndAt = moment(resultsSorted[i - 1].end_at)

      const startAt = moment(resultsSorted[i].start_at)
      const endAt = moment(resultsSorted[i].end_at)

      // Remove observer object
      const prevData = JSON.parse(JSON.stringify(resultsSorted[i - 1]))
      const currentData = JSON.parse(JSON.stringify(resultsSorted[i]))

      if (prevData.user_name === currentData.user_name) {
        // Split row here
        if (startAt > prevStartAt && endAt < prevEndAt) {
          newCsvValues[newCsvValues.length - 1].end_at = currentData.start_at
          newCsvValues.push(currentData)

          prevData.start_at = endAt.format(this.dateTimeFormat)
          prevData.end_at = prevEndAt.format(this.dateTimeFormat)
          newCsvValues.push(prevData)
          continue
        }

        if (startAt < prevEndAt) {
          newCsvValues[newCsvValues.length - 1].end_at = currentData.start_at
          newCsvValues.push(currentData)
          continue
        }
      }

      newCsvValues.push(resultsSorted[i])
    }

    this.csvValues = newCsvValues
  }

  async mounted() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.isPlaceMode = this.filterUtilPlaceMode.get(this.isPlaceMode)
    const calendar = this.getCalendarApi()
    if (calendar) {
      calendar.gotoDate(this.pageFilters.dateFrom)
    }

    this.isReady = true
  }

  async created() {
    await this.initFetch()

    const isExistCarriedBeacons = this.beacons.findIndex(
      beacon => beacon.beacon_type === Constant.BEACON_TYPE_CARRIED
    )
    if (isExistCarriedBeacons >= 0) {
      await this.getCardStatic()
    }
  }
}
